import { defineComponent, ref } from 'vue-demi';
import _ from 'lodash';
import { useToggle, onClickOutside } from '@vueuse/core';
import { openBlock, createElementBlock, createElementVNode, resolveComponent, normalizeClass, Fragment, renderList, createVNode, withCtx, createTextVNode, toDisplayString, normalizeStyle, withModifiers, createCommentVNode } from 'vue';
import { s as styleInject } from './style-inject.es-20d2f1f5.js';

function arrayMove(array, from, to) {
  let on = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
  return array = array.slice(), array.splice(to, 0, ...array.splice(from, on)), array;
}

var script$1 = defineComponent({});

const _hoisted_1$1 = {
  id: "Capa_1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 35 35",
  style: {
    "enable-background": "new 0 0 32.055 32.055"
  },
  "xml:space": "preserve"
};
const _hoisted_2$1 = /*#__PURE__*/createElementVNode("g", {
  transform: "translate(1, 2)"
}, [/*#__PURE__*/createElementVNode("path", {
  d: "M3.968,12.061C1.775,12.061,0,13.835,0,16.027c0,2.192,1.773,3.967,3.968,3.967c2.189,0,3.966-1.772,3.966-3.967\n\t\tC7.934,13.835,6.157,12.061,3.968,12.061z M16.233,12.061c-2.188,0-3.968,1.773-3.968,3.965c0,2.192,1.778,3.967,3.968,3.967\n\t\ts3.97-1.772,3.97-3.967C20.201,13.835,18.423,12.061,16.233,12.061z M28.09,12.061c-2.192,0-3.969,1.774-3.969,3.967\n\t\tc0,2.19,1.774,3.965,3.969,3.965c2.188,0,3.965-1.772,3.965-3.965S30.278,12.061,28.09,12.061z"
})], -1 /* HOISTED */);
const _hoisted_3$1 = [_hoisted_2$1];
function render$1(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1$1, _hoisted_3$1);
}

script$1.render = render$1;
script$1.__file = "src/components/IconDots.vue";

const localCache = {
  firstHiddenIndex: -1
};
var script = defineComponent({
  name: 'ServiceNavigationMenu',
  components: {
    IconDots: script$1
  },
  props: {
    items: {
      type: Array,
      required: true
    },
    inverted: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    const menu = ref();
    const [showMore, toggle] = useToggle();
    onClickOutside(menu, () => {
      toggle(false);
    });
    return {
      showMore,
      toggle,
      menu
    };
  },
  data() {
    return {
      firstHiddenIndex: localCache.firstHiddenIndex ,
      firstHiddenRightBorder: undefined
    };
  },
  computed: {
    moreItems() {
      if (this.firstHiddenIndex == -1) {
        return [];
      }
      return this.orderedItems.slice(this.firstHiddenIndex);
    },
    activeIndex() {
      return _.findIndex(this.items, _ref => {
        let {
          url
        } = _ref;
        return this.isActive(url);
      });
    },
    orderedItems() {
      if (this.firstHiddenIndex > 0 && this.activeIndex >= this.firstHiddenIndex) {
        return arrayMove(this.items, this.activeIndex, this.firstHiddenIndex - 1);
      }
      return this.items;
    }
  },
  watch: {
    moreItems(val) {
      if (val.length == 0) {
        this.toggle(false);
      }
      this.getUpdateLastVisibleIndexThrottled();
    }
  },
  mounted() {
    this.getUpdateLastVisibleIndexThrottled();
  },
  created() {
    window.addEventListener('resize', this.getUpdateLastVisibleIndexThrottled);
  },
  destroyed() {
    window.removeEventListener('resize', this.getUpdateLastVisibleIndexThrottled);
  },
  methods: {
    isActive(url) {
      var _a, _b;
      // @ts-ignore
      return ((_b = (_a = this.$router) === null || _a === void 0 ? void 0 : _a.matcher) === null || _b === void 0 ? void 0 : _b.match(url).name) === this.$route.name;
    },
    // eslint-disable-next-line no-unused-vars
    getUpdateLastVisibleIndexThrottled: _.throttle(function () {
      this.$nextTick(() => {
        // done by getElementsByClassName because of ref limitations on @vue/composition-api
        if (this.$refs.menu) {
          const menuItems = this.$refs.menu.getElementsByClassName('service-navigation-menu-items');
          if (menuItems && this.$refs.menu) {
            const containerBorder = this.$refs.menu.getBoundingClientRect().width - 30;
            this.firstHiddenIndex = [...menuItems].findIndex(e => {
              if (e) {
                return e.offsetLeft + e.clientWidth > containerBorder;
              }
            });
            this.firstHiddenRightBorder = this.firstHiddenIndex != -1 ? menuItems[this.firstHiddenIndex].offsetLeft : undefined;
          }
        }
      });
    }, 150)
  }
});

const _hoisted_1 = {
  class: "menu-items-list"
};
const _hoisted_2 = {
  key: 0,
  class: "row more-items-container",
  "data-test": "menu-more-container"
};
const _hoisted_3 = {
  class: "more-items-list"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = resolveComponent("router-link");
  const _component_icon_dots = resolveComponent("icon-dots");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass({
      'menu': true,
      'inverted': _ctx.inverted
    }),
    "data-test": "menu"
  }, [createElementVNode("div", {
    ref: "menu",
    class: normalizeClass({
      'row': true,
      'menu-container': true,
      'with-trigger': _ctx.moreItems.length > 0
    })
  }, [createElementVNode("div", _hoisted_1, [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.orderedItems, (item, index) => {
    return openBlock(), createElementBlock("div", {
      key: item.label,
      ref_for: true,
      ref: "menu-items",
      "data-test": "menu-item",
      class: normalizeClass({
        'service-navigation-menu-items': true,
        'menu-item': true,
        'in-visible-area': _ctx.firstHiddenIndex === -1 || index < _ctx.firstHiddenIndex
      })
    }, [createVNode(_component_router_link, {
      to: item.url
    }, {
      default: withCtx(() => [createTextVNode(toDisplayString(item.label), 1 /* TEXT */)]),

      _: 2 /* DYNAMIC */
    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"])], 2 /* CLASS */);
  }), 128 /* KEYED_FRAGMENT */))]), _ctx.moreItems.length ? (openBlock(), createElementBlock("div", {
    key: 0,
    class: normalizeClass({
      'more-items-trigger': true,
      'active': _ctx.showMore
    }),
    style: normalizeStyle({
      left: _ctx.firstHiddenRightBorder ? `${_ctx.firstHiddenRightBorder}px` : false
    }),
    "data-test": "menu-more-trigger",
    onClick: _cache[0] || (_cache[0] = withModifiers($event => _ctx.toggle(), ["prevent"]))
  }, [createVNode(_component_icon_dots)], 6 /* CLASS, STYLE */)) : createCommentVNode("v-if", true)], 2 /* CLASS */), _ctx.showMore ? (openBlock(), createElementBlock("div", _hoisted_2, [createElementVNode("div", _hoisted_3, [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.moreItems, item => {
    return openBlock(), createElementBlock("div", {
      key: item.label,
      class: "menu-item more-item",
      "data-test": "more-menu-item"
    }, [createVNode(_component_router_link, {
      to: item.url
    }, {
      default: withCtx(() => [createTextVNode(toDisplayString(item.label), 1 /* TEXT */)]),

      _: 2 /* DYNAMIC */
    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"])]);
  }), 128 /* KEYED_FRAGMENT */))])])) : createCommentVNode("v-if", true)], 2 /* CLASS */);
}

var css_248z = "/**\n * A simple way to manage mobile breakpoints described in https://davidwalsh.name/write-media-queries-sass.\n * Can be further extended using following approach https://rimdev.io/making-media-query-mixins-with-sass/\n */\n@keyframes spinAround-4d21a3a8 {\nfrom {\n    transform: rotate(0);\n}\nto {\n    transform: rotate(359deg);\n}\n}\n@keyframes fade-4d21a3a8 {\nfrom {\n    opacity: 1;\n}\nto {\n    opacity: 0;\n}\n}\n.menu[data-v-4d21a3a8] {\n  position: relative;\n  z-index: 45;\n  display: grid;\n  width: 100%;\n  height: 100%;\n}\n.menu.inverted .menu-item a.router-link-active[data-v-4d21a3a8] {\n  color: var(--c-neutral-0);\n  background-color: var(--c-neutral-6);\n}\n.menu.inverted .more-items-trigger.active[data-v-4d21a3a8] {\n  background-color: var(--c-neutral-2);\n}\n@media only screen and (max-width: 768px) {\n.menu[data-v-4d21a3a8] {\n    z-index: 2;\n}\n}\n.menu .row[data-v-4d21a3a8] {\n  display: grid;\n  overflow: hidden;\n}\n.menu .row.menu-container[data-v-4d21a3a8] {\n  position: relative;\n  align-items: center;\n}\n.menu .menu-items-list[data-v-4d21a3a8] {\n  display: inline-grid;\n  grid-auto-flow: column;\n  justify-self: center;\n  max-width: max-content;\n}\n.menu .menu-item[data-v-4d21a3a8] {\n  width: min-content;\n  height: 22px;\n  margin: 0 auto;\n  text-align: center;\n}\n.menu .menu-item.in-visible-area a[data-v-4d21a3a8] {\n  visibility: visible;\n}\n.menu .menu-item.more-item a[data-v-4d21a3a8] {\n  visibility: visible;\n}\n.menu .menu-item a[data-v-4d21a3a8] {\n  display: block;\n  padding: var(--s-2) 12px;\n  margin: 0 1vw;\n  font-size: var(--fs-0);\n  font-weight: bold;\n  line-height: 14px;\n  color: var(--c-neutral-5);\n  text-decoration: none;\n  white-space: nowrap;\n  visibility: hidden;\n}\n.menu .menu-item a.router-link-active[data-v-4d21a3a8] {\n  align-self: center;\n  height: 100%;\n  color: var(--c-neutral-6);\n  background-color: var(--c-neutral-0);\n  border-radius: 11px;\n}\n.menu .more-items-trigger[data-v-4d21a3a8] {\n  position: absolute;\n  width: 25px;\n  height: 25px;\n  padding: 5px;\n  line-height: 1;\n  cursor: pointer;\n  background: var(--c-neutral-6);\n}\n.menu .more-items-trigger.active[data-v-4d21a3a8] {\n  background: rgba(223, 223, 223, 0.2117647059);\n  border-radius: 15px;\n}\n@media (min-width: 769px) {\n.menu .more-items-trigger[data-v-4d21a3a8] {\n    top: 11px;\n    width: 25px;\n    height: 25px;\n    background-color: transparent;\n}\n}\n@media only screen and (max-width: 768px) {\n.menu .more-items-trigger[data-v-4d21a3a8] {\n    right: var(--s-4) !important;\n    left: auto !important;\n    background: var(--c-neutral-0);\n}\n}\n.menu .more-items-trigger svg[data-v-4d21a3a8] {\n  fill: var(--c-neutral-0);\n}\n@media only screen and (max-width: 768px) {\n.menu .more-items-trigger svg[data-v-4d21a3a8] {\n    fill: var(--c-neutral-5);\n}\n}\n.menu .more-items-container[data-v-4d21a3a8] {\n  position: absolute;\n  top: 100%;\n  width: 100%;\n  background-color: var(--c-neutral-6);\n}\n@media only screen and (max-width: 768px) {\n.menu .more-items-container[data-v-4d21a3a8] {\n    background-color: var(--c-neutral-0);\n    border-bottom: 1px solid var(--c-neutral-2);\n}\n}\n.menu .more-items-container .more-items-list .menu-item[data-v-4d21a3a8] {\n  margin: 10px auto;\n}";
styleInject(css_248z);

script.render = render;
script.__scopeId = "data-v-4d21a3a8";
script.__file = "src/components/ServiceNavigationMenu.vue";

export { script as s };
